export const getDesktopAdUnit = (position: number) => {
  switch (position) {
    case 0:
      return "d_lrec1";
    case 1:
      return "d_lrec3";
    default:
      return "d_lrec2";
  }
};

export const getTabletAdUnit = (position: number) => {
  switch (position) {
    case 0:
      return "m_lrec1";
    case 1:
      return "m_lrec3";
    default:
      return "m_lrec2";
  }
};

export const getMobileAdUnit = (position: number) => {
  switch (position) {
    case 0:
      return "m_banner1";
    case 1:
      return "m_lrec1";
    default:
      return "m_lrec3";
  }
};
